import VueQrcode from "vue-qrcode";
import directDebit from "@/services/modules/directDebit";
import dayjs from "@/utiles/dayjs";

const DirectDebitTable = () =>
  import(
    "@/components/OperationsPage/Deposit/Rial/DirectDebit/DirectDebitTable/index"
  );
const chooseBank = () =>
  import(
    "@/components/OperationsPage/Deposit/Rial/DirectDebit/ChooseBank/index"
  );
const createContractForm = () =>
  import(
    "@/components/OperationsPage/Deposit/Rial/DirectDebit/CreateContractForm/index"
  );
export default {
  name: "directDebit",
  components: { DirectDebitTable, VueQrcode, chooseBank, createContractForm },
  props: [],
  filters: {
    formatDate(date) {
      return dayjs(date).format("YYYY/MM/DD");
    }
  },
  data() {
    return {
      deleteLoadingBtn: false,
      mode: "firstSection",
      contractList: null,
      pageInfo: "",
      contractChoose: null,
      showDeleteModal: false,
      contractDetails: null
    };
  },
  mounted() {
    this.getContract();
    this.getPageInfo();
  },
  methods: {
    getContract() {
      directDebit.getAllContracts().then(res => {
        this.contractList = res.data.data;
      });
    },
    deleteContract() {
      this.deleteLoadingBtn = true;
      directDebit
        .deleteContract(this.contractDetails.id)
        .then(() => {
          this.showDeleteModal = false;
          this.getContract();
        })
        .finally(() => {
          this.deleteLoadingBtn = false;
        });
    },
    getPageInfo() {
      directDebit.pageInfo().then(res => {
        this.pageInfo = res.data.data;
      });
    },
    quickDeposit() {
      this.mode = "createContractForm";
      localStorage.setItem("chooseItem", JSON.stringify(this.contractChoose));
    },
    openDeleteModal(item) {
      this.contractDetails = item;
      this.showDeleteModal = true;
    },
    changeMode(mode) {
      this.mode = mode;
    },
    onCopy() {
      this.$toast.success(
        this.$t("operationsPage.deposit.category.rial.directDebit.copy")
      );
    }
  }
};
